import styled, { css } from 'styled-components';
import { isMaps } from '../../../modules/checkDeployEnv';

const NAV_BAR_HEIGHT = 56;
const FOOTER_HEIGHT = 60;
const HEADER_HEIGHT = 49; // in sm
const HEADER_HEIGHT_2 = HEADER_HEIGHT + 4;
const HEADER_HEIGHT_3 = HEADER_HEIGHT + 45;
const HEADER_HEIGHT_4 = HEADER_HEIGHT + 90;
const HEADER_HEIGHT_5 = HEADER_HEIGHT + 28 + 8;
const HEADER_HEIGHT_6 = HEADER_HEIGHT * 2;
const HEADER_HEIGHT_7 = HEADER_HEIGHT + 60;
const SEARCH_ITEM_HEIGHT = 38;

const caculateMapHeight = ({
  height,
  hasSearchItem,
  isFixedHeight,
  headerType,
  isMaxHeightLow,
  isFullScreen,
  isThumbnailMap,
  deployEnv,
  isAtlas
}) => {
  let totalHeightToRemove = NAV_BAR_HEIGHT;
  if (!isMaps(deployEnv)) {
    totalHeightToRemove += FOOTER_HEIGHT;
  }
  if (isThumbnailMap) {
    return '100%';
  }
  if (isAtlas) {
    return '100%';
  }
  if (isFullScreen) {
    return '100vh';
  }
  if (isFixedHeight) {
    return height;
  }
  if (isMaxHeightLow) {
    return '600px';
  }
  let finalHeightToRemove = totalHeightToRemove;
  switch (headerType) {
    case '1':
      finalHeightToRemove += HEADER_HEIGHT;
      break;
    case '3':
      finalHeightToRemove += HEADER_HEIGHT_2;
      break;
    case '4':
      finalHeightToRemove += HEADER_HEIGHT_3;
      break;
    case '5':
      finalHeightToRemove += HEADER_HEIGHT_4;
      break;
    case '6':
      finalHeightToRemove += HEADER_HEIGHT_5;
      break;
    case '7':
      finalHeightToRemove += HEADER_HEIGHT_6;
      break;
    case '8':
      finalHeightToRemove += HEADER_HEIGHT_7;
      break;
    default:
      break;
  }
  if (hasSearchItem) {
    return `calc(${height} - ${finalHeightToRemove + SEARCH_ITEM_HEIGHT}px)`;
  }
  return `calc(${height} - ${finalHeightToRemove}px)`;
};

const Map = styled.div`
  z-index: ${props => (props.isThumbnailMap ? 2 : 0)};
  border-radius: ${props => (props.isThumbnailMap ? '5px' : 0)};
  height: ${props => caculateMapHeight(props)};
  @media screen and (max-height: 660px) {
    height: ${props => caculateMapHeight({ ...props, isMaxHeightLow: true })};
  }
  ${props =>
    props.isRounded &&
    css`
      border-radius: 15px;
    `};
  ${props =>
    props.isThumbnailMap &&
    css`
      width: 100%,
      position: 'inherit'
    `};
`;
export default {
  Map
};
